import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Navbar from './Navbar'
import Breadcrumb from 'react-bootstrap/Breadcrumb'

class Landing extends Component {
    render() {
        return (
            <div data-test='landingComponent' id="background-img">
                <Navbar />

                <Breadcrumb>
                    <Breadcrumb.Item href="">
                        <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
                    <Breadcrumb.Item href="/welcome" active>
                       Welcome
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className="container">
                    <div className="row" style={{ paddingTop: "5%" }}>
                        <div style={{ margin: "auto" }}>
                            <h1 style={{ color: "#464646" }}>Welcome!</h1>
                        </div>
                    </div>
                    <div className="row" style={{ paddingTop: "8%" }}>
                        <div className="col-md-6">
                            <Link to="/open_loop" style={{ textDecoration: "none" }}>
                                <div className="card" id="info-box">
                                    <div className="card-body align-items-center d-flex justify-content-center">
                                        <h4 style={{ color: "#622AD8" }}>Open Loop Validation</h4>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-6">
                            <Link to="/close_loop" style={{ textDecoration: "none" }}>
                                <div className="card" id="info-box">
                                    <div className="card-body align-items-center d-flex justify-content-center">
                                        <h4 style={{ color: "#622AD8" }}>Close Loop Validation</h4>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }


export default Landing
